
/**
 * PDF文件查看器
 */
import React, { Component } from 'react';
import { Modal } from 'antd';


import http from '../../axios/http';
import { getBase64 } from '../../util/util.js';

class PdfViewer extends Component {

    state = {
        file: null,
        clientW: 200,
        clientH: 200,
    }

    componentDidMount() {
        let clientW = document.body.clientWidth;
        let clientH = document.body.clientHeight;
        this.setState({
            clientW: clientW,
            clientH: clientH - 200
        });
    }


    /**
    * 加载文件
    * @param  options 
    * {
    * url: '文件对应的服务器路径', 必须 
    * fileName: '文件名', 非必须
    * data: {},   //请求参数，非必须
    * saveFile: false, //是否同时保存文件，如果这个为true时，fileName为必填，默认为下载
    * }
    */
    loadFile = (options) => {
        http.download({
            url: options.url,
            data: options.data,
            fileName: options.fileName == null ? "temp.pdf" : options.fileName,
            saveFile: false,
            success: (res) => {
                getBase64(res.data).then(base64 => {
                    this.setState({ file: base64 });
                });
                if (options.success) {
                    options.success(res);
                }
            },
            error: (res) => {
                if (options.error) {
                    options.error(res);
                }
            }
        });
    }

    /**
     * 设置文件
     * @param {*} file 
     */
    setFile = (file) => {
        this.setState({ file: file });
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width='80%'
                visible={visible}
                title="文件查看"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                bodyStyle={{ padding: 0 }}
                afterClose={() => {
                    this.setState({ file: null })
                }}
                footer={null}
            >
                <div style={{ width: '100%', height: this.state.clientH }}>
                    {this.state.file == null ? ""
                        : <embed width="100%" height="100%" src={this.state.file} type="application/pdf" />
                    }
                </div>
            </Modal>
        );
    }
}


export default PdfViewer;